import { Link, NavLink } from 'react-router';
import styled from 'styled-components';

export const FooterStyled = styled.footer`
  padding: 50px 100px 24px 100px;
  background: linear-gradient(
    183.17deg,
    #84d2ff 0.39%,
    #1d69b0 26.92%,
    #13151f 81.78%
  );

  img {
    width: 220px;
  }

  @media (max-width: 1000px) {
    img {
      width: 150px;
    }
  }
`;

export const FooterText = styled.p`
  font-family: Outfit;
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.white};
`;

export const FooterLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.white};
`;
